export const GroupType = Object.freeze({
    OVERWRITE: "overwrite",
    ADD: "add",
    INTRODUCTION: "introduction",
    LEADING_SUMMARY: "leadingSummary",
})
